import React, { SyntheticEvent, useState } from "react";
import { Modal, ModalBody } from "reactstrap";

import { IRequirements } from "../../pages/interfaces/IRequirements";

import { FormFields, GT } from "..";
import { useFetchData } from "hooks/useFetchData";

interface IProps {
    isOpen: boolean;
    requirements: IRequirements;
    permCode: string;
    submit: (e: SyntheticEvent, reqParams: IReqParams) => void;
    toggleModal: (state: boolean) => void;
    onClose?: () => void;
}

const CustomModalRequirement = ({ isOpen, requirements, permCode, submit, toggleModal, onClose }: IProps) => {
    const [errors, setErrors] = useState({} as IErrors);
    const [formData, setFormData] = useState<any>({ password: "", additionalPassword: "", comment: "" });
    const [modalOpen, setModalOpen] = useState<boolean>(isOpen);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { password, additionalPassword, comment, additionalUser } = formData;

    const handleSubmitData = async (e) => {
        e.preventDefault();
        e.persist();

        const reqParams = {
            password,
            comment,
            additional_password: additionalPassword,
            additional_user: additionalUser,

            permCode,
        };

        if (!handleValidation()) return;

        setIsLoading(true);

        const resp: any = await submit(e, reqParams);

        if (
            typeof resp == "object" &&
            (resp.hasOwnProperty("reqPassword") || resp.hasOwnProperty("reqComment") || resp.hasOwnProperty("reqAdditionalPassword"))
        )
            setErrors(resp), setIsLoading(false);
        else {
            setIsLoading(false);
            setModalOpen(false);
            setTimeout(() => {
                toggleModal(false);
                // timeout = 150 is important due to transition modal
            }, 150);
        }
    };

    const handleValidation = () => {
        let isValid = true;

        if (requirements.requirePassword && !password.length) {
            setErrors((prevState) => ({ ...prevState, password: "Password is required" }));
            isValid = false;
        } else setErrors((prevState) => ({ ...prevState, password: "" }));

        if (requirements.requireComment && !comment.length) {
            setErrors((prevState) => ({ ...prevState, comment: "Comment is required" }));
            isValid = false;
        } else setErrors((prevState) => ({ ...prevState, comment: "" }));
        if (requirements.requireAdditionalPassword && !additionalPassword.length) {
            setErrors((prevState) => ({ ...prevState, additionalPassword: "Additional password is required" }));
            isValid = false;
        } else setErrors((prevState) => ({ ...prevState, additionalPassword: "" }));

        return isValid;
    };

    const fields: IFormField[] = [
        {
            fieldType: "input",
            name: "password",
            label: "Password",
            display: requirements.requirePassword,
            props: {
                type: "password",
                autoComplete: "current-password",
                id: "transaction-password",
            },
        },
        {
            fieldType: "custom",
            name: "",
            customElement: <hr />,
            display: requirements.requireAdditionalPassword,
        },
        {
            fieldType: "primeSelect",
            name: "additionalUser",
            label: "User",
            url: "bs/users-form-data",
            options: (options) => options?.userCollection?.filter((user) => user.value != options.currentUser),
            display: requirements.requireAdditionalPassword,
        },
        {
            fieldType: "input",
            name: "additionalPassword",
            label: "Additional password",
            display: requirements.requireAdditionalPassword,
            props: {
                type: "password",
                autoComplete: "current-password",
                id: "transaction-additional-password",
            },
        },
        {
            fieldType: "textarea",
            name: "comment",
            label: "Comment",
            display: requirements.requireComment,
        },
    ];

    const handleCloseModal = async () => {
        setIsLoading(false);
        onClose && onClose();
        setModalOpen(false);
        setTimeout(() => {
            toggleModal(false);
            // timeout = 150 is important due to transition modal
        }, 150);
    };

    return (
        <React.Fragment>
            <Modal isOpen={modalOpen} toggle={handleCloseModal} fade id="custom-modal-requirement">
                <GT.ModalHeader closeModal={handleCloseModal} name="Transaction authorization" />
                <ModalBody>
                    {/* This line prevents chrome from capturing random user inputs eg. filter user*/}
                    <input style={{ transform: "translateX(1000000px)", position: "absolute" }} name="user" autoComplete="on"></input>
                    <FormFields formData={formData} setFormData={setFormData} errors={errors} fields={fields} />
                </ModalBody>
                <GT.ModalFooter
                    closeModal={handleCloseModal}
                    cancelName="Cancel"
                    okName="Authorize"
                    isBusy={isLoading}
                    onClick={handleSubmitData}
                />
            </Modal>
        </React.Fragment>
    );
};

export default CustomModalRequirement;
